<template>
    <v-container fluid>
        <v-layout class="align-center">
            <v-flex>
                <h2 class="headline">Biler</h2>
            </v-flex>
            <v-spacer/>
            <v-flex shrink>
                <edit-car-dialog @save="redirectToCar"/>
            </v-flex>
        </v-layout>

        <div class="filter-container">
            <affix relative-element-selector="#cars" :offset="{top: 150, bottom: 200}">
                <car-filter @filter="applyFilter($event)" class="mb-3" />
            </affix>
        </div>

        <car-table id="cars" ref="carTable"/>

        <v-btn class="mt-2" color="green darken-1" dark @click="printPage">
            <v-icon>print</v-icon>
            Skriv ut
        </v-btn>
    </v-container>
</template>

<script>
    import EditCarDialog from '../helpers/EditCarDialog';
    import CustomerCardPopup from '../helpers/CustomerCardPopup';
    import CarFilter from '../helpers/filter/CarFilter';
    import CarTable from '../helpers/CarTable';

    export default {
        name: 'CarIndex',
        components: {
            EditCarDialog,
            CustomerCardPopup,
            CarFilter,
            CarTable
        },

        methods: {
            redirectToCar(car) {
                this.$router.push({name: 'CarShow', params: {id: car.id}});
            },

            applyFilter(filter) {
                this.$refs.carTable.loadData(filter);
            },

            printPage() {
                window.print();
            }
        }
    }
</script>
